import { createElement, type ReactNode } from 'react';
import {
  IconFileDescription,
  IconFileText,
  IconFileTypeDoc,
  IconFileTypePdf,
} from '@tabler/icons-react';

interface FileAppearance {
  color: string;
  icon: ReactNode;
}

export const getFilenameExtension = (filename: string): string =>
  filename.split('.').pop()?.toLowerCase() ?? '';

export const getFileAppearance = (filename: string): FileAppearance => {
  const extension = getFilenameExtension(filename);

  if (extension === 'pdf') {
    return {
      color: 'gray',
      icon: createElement(IconFileTypePdf, { size: 24 }),
    };
  }
  if (extension === 'doc' || extension === 'docx') {
    return {
      color: 'gray',
      icon: createElement(IconFileTypeDoc, { size: 24 }),
    };
  }
  if (extension === 'txt') {
    return { color: 'gray', icon: createElement(IconFileText, { size: 24 }) };
  }

  return {
    color: 'gray',
    icon: createElement(IconFileDescription, { size: 24 }),
  };
};
